import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { ICartSummary } from "@signature-it/ngx-catalogue/interfaces";

export class CartSummaryDTO extends AbstractDTO implements ICartSummary {
    ItemCode: string;
    DeliveryDays: number;
    DeliveryPrice: number;
    TotalItemsPrice: number;
    TotalPrice: number;
    TotalPriceBeforeDiscount: number;
    TotalPriceAfterDiscount: number;
    TotalDiscount: number;
    Vat: number;
    SessionCurrency: string;
    Points: number;
    DeliveryDiscount: number;
    AdditionalData: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes || {};

        this.ItemCode = attributes['ItemCode'] || '';
        this.DeliveryDays = Number(attributes['DeliveryDays']) || 0;
        this.DeliveryPrice = Number(attributes['DeliveryPrice']) || 0;
        this.TotalItemsPrice = Number(attributes['TotalItemsPrice']) || 0;
        this.TotalPrice = Number(attributes['TotalPrice']) || 0;
        this.TotalPriceBeforeDiscount = Number(attributes['TotalPriceBeforeDiscount']) || 0;
        this.TotalPriceAfterDiscount = Number(attributes['TotalPriceAfterDiscount']) || 0;
        this.Vat = Number(attributes['Vat']) || 0;
        this.SessionCurrency =  attributes['SessionCurrency'] || 'USD';
        this.Points = Number(attributes['calculated_points']) || 0;
        this.DeliveryDiscount = Number(attributes['delivery_discount']) || 0;
        this.AdditionalData = attributes['additional_data'] || null;
    }

    calTotalItemsPrice() {
        const price = this.TotalPriceBeforeDiscount > 0 ? this.TotalPriceBeforeDiscount : 0;
        const delivery = this.DeliveryPrice > 0 ? this.DeliveryPrice : 0;
        this.TotalItemsPrice = delivery ? price - delivery : price;
    }

    calcTotalPrice() {
        const DeliveryPrice =  Number(this.DeliveryPrice) < 0 ? 0 :this.DeliveryPrice;
        const Vat = Number(this.Vat) < 0 ? 0 :this.Vat;
        this.TotalPrice = this.TotalPriceBeforeDiscount + DeliveryPrice + Vat - this.Points - this.DeliveryDiscount;
    }

    calcDiscountTotalPrice() {
        this.TotalDiscount = this.TotalPriceBeforeDiscount  - this.TotalPriceAfterDiscount;
    }

    hasDiscountPrice(): boolean {
        return this.TotalPriceBeforeDiscount !== this.TotalPriceAfterDiscount;
    }

}
